export const GET_ACCOUNT_BY_ID = 'app/credit/getAccountById';
export const MANAGE_ACCOUNT = 'app/credit/manageAccount';
